import axios from 'axios';
import ReactMarkdown from 'react-markdown';

import SiteHeader from '../components/shared/SiteHeader';

import { getStrapiURL } from '../lib/api';
const apiBaseUrl = getStrapiURL();

const PrivacyPolicy = ({ privacyPolicy, seo }) => {
  return (
    <>
      <SiteHeader
        title={'AlmaBetter’s Privacy Policy & Terms and Conditions '}
        desc={
          'Get familiar with our Privacy Policy. Learn about how we collect, use, and share your data, and our commitment to protecting the privacy of our customers.'
        }
        url={'/privacy-policy'}
        image={seo?.image?.data?.attributes?.url}
      />
      <div className="container-default-1209px">
        <div className="my-20 mx-10 flex flex-col items-start lg:mx-40">
          <h1 className="mb-3 font-satoshi-bold text-2xl font-bold ">Privacy Policy</h1>
          <div>Last updated: January 1, 2022</div>
          <hr
            className="mb-10"
            style={{
              marginBottom: '0px',
              marginTop: '24px',
              borderColor: 'var(--grey-3)',
            }}
          />
          <h2 className="mb-3 text-lg">Privacy Policy at AlmaBetter</h2>
          <ReactMarkdown
            components={{
              h1: (props) => <h1 {...props} className="mb-4 text-xl" />,
              p: (props) => <p {...props} className="mb-8 text-justify text-base" />,
              a: ({ node, href, children, ...props }) => (
                <a {...props} href={href}>
                  <a className="text-base text-blue hover:underline">{children}</a>
                </a>
              ),
              ul: ({ node, ...props }) => <ul {...props} className="list-inside list-disc" />,
              strong: ({ node, ...props }) => (
                <span {...props} className="font-satoshi-bold text-base font-bold " />
              ),
              li: ({ node, ...props }) => <li {...props} className="text-base" />,
              ol: ({ node, ...props }) => (
                <ol
                  {...props}
                  className="mb-4 list-inside list-decimal font-satoshi-bold font-bold "
                />
              ),
            }}
          >
            {privacyPolicy}
          </ReactMarkdown>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;

export async function getStaticProps(context) {
  try {
    const { data } = await axios.get(`${apiBaseUrl}/api/privacy-policy?populate=highlights.image`);
    const { data: seoData } = await axios.get(`${apiBaseUrl}/api/global?populate=seo.image`);
    return {
      props: {
        privacyPolicy: data.data.attributes.PrivacyPolicy || {},
        seo: seoData.data.attributes.seo,
      },
      revalidate: 3600,
    };
  } catch (error) {
    return { props: { error } };
  }
}
